var App = App || {};

App.BillingForm = (function ($) {
	"use strict"; 

	function toggleRegionSelect($el) {
		$el.prop({
			required: $el.find("option").length > 1
		});
	}

	function init() {
		const $billingForm = $("form#checkout-billing"),
			$createAccountButton = $billingForm.find("#checkout-create-account"),
			$country = $billingForm.find("#billingAddress_CountryIsoCode"),
			$region = $billingForm.find("#billingAddress_State");

		$country.on("change", function () {
			const countryCode = $(this).val();
			$region.empty();

			if (!countryCode) {
				return;
			}

			$.ajax({
				url: "/api/cart/regions",
				method: "GET",
				data: { countryCode: countryCode },
				dataType: "json"
			}).done(function (regions) {
				if (!regions || regions.length === 0) {
					$region.append($("<option>", {
						value: "",
						text: "N/a"
					}));
					return;
				}

				$region.append($("<option>", {
					value: "",
					text: "Select"
				}));

				$.each(regions, function (_, r) {
					$region.append($("<option>", {
						value: r.code,
						text: r.name
					}));
				});
			}).fail(function () {

			}).always(function () {
				toggleRegionSelect($region);
			});
		});

		$billingForm.on("submit", function (e) {
			e.preventDefault();

			var $form = $(this),
				$summary = $form.find(".form-validation-message"),
				$submitButton = $form.find('button[type="submit"]');

			$summary.empty();

			if ($form[0].checkValidity()) {
				App.Spinner.startSpinner($submitButton, "Processing");
				var payload = {
					firstName: $form.find("#billingAddress_FirstName").val(),
					lastName: $form.find("#billingAddress_LastName").val(),
					email: $form.find("#billingAddress_Email").val(),
					company: $form.find("#billingAddress_Company").val(),
					addressLine1: $form.find("#billingAddress_AddressLine1").val(),
					addressLine2: $form.find("#billingAddress_AddressLine2").val(),
					city: $form.find("#billingAddress_City").val(),
					state: $form.find("#billingAddress_State").val(),
					zipCode: $form.find("#billingAddress_ZipCode").val(),
					telephone: $form.find("#billingAddress_Telephone").val(),
					countryIsoCode: $form.find("#billingAddress_CountryIsoCode").val(),
					storeId: $form.find("#billingAddress_StoreId").val()
				};
				var token = $('meta[name="request-verification-token"]').attr('content');
				$.ajax({
					url: '/api/cart/update_billing',
					contentType: 'application/json; charset=utf-8',
					method: 'POST',
					data: JSON.stringify(payload),
					headers: { 'RequestVerificationToken': token },
					dataType: 'json'
				}).done(function (data, textStatus, jqXHR) {
					if ($submitButton.data("can-finalize")) {
						$.ajax({
							url: '/api/cart/finalize',
							contentType: 'application/json; charset=utf-8',
							method: 'POST',
							headers: { 'RequestVerificationToken': token },
							dataType: 'json'
						}).done(function (data, textStatus, jqXHR) {
							window.location.href = "/checkout/checkout-confirmation?orderId=" + data.orderSummary.orderId;
						}).fail(function (jqXHR) {
							App.Base.ShowError("Unable to complete request. Please try again.");
							App.Spinner.stopSpinner($submitButton);
						});
					} else {
						window.location.href = "/checkout/checkout-payment-information"
					}
				}).fail(function (jqXHR) {
					App.Base.ShowError("Unable to complete request. Please try again.");
					App.Spinner.stopSpinner($submitButton);
				});
			} else {
				$form.addClass('was-validated');
			}
		});

		$createAccountButton.on("click", function () {
			const $form = $("form#checkout-billing"),
				$offcanvas = $("#register-offcanvas");

			$offcanvas.find("#register-first-name")
				.val($form.find("#billingAddress_FirstName").val());

			$offcanvas.find("#register-last-name")
				.val($form.find("#billingAddress_LastName").val());

			$offcanvas.find("#register-email")
				.val($form.find("#billingAddress_Email").val());

			const offcanvas = new bootstrap.Offcanvas('#register-offcanvas');
			offcanvas.show();
		});

		toggleRegionSelect($region);
	}

	return {
		init: init
	};

})(jQuery);

$(function () {
	App.BillingForm.init();
});